import { ABodyColor, ABodySize, type ABodyProps } from '../../atoms/ABody/ABody.types';
import { AEyebrowVariant, type AEyebrowProps } from '../../atoms/AEyebrow/AEyebrow.types';
import { AHeaderSize, AHeaderTag, type AHeaderProps } from '../../atoms/AHeader/AHeader.types';

export enum MTextBlockSimpleAlignment {
  Left = 'Left',
  Center = 'Center',
}

export interface MTextBlockSimpleProps {
  alignment?: MTextBlockSimpleAlignment;

  /**
   * @deprecated Use the nested `aEyebrow.eyebrowText` instead. Flat text props
   * are outdated in mi-web-ui-kit and will be removed in a future major version.
   */
  eyebrowText?: string;
  /** @deprecated Use `aEyebrow.variant` instead. */
  eyebrowVariant?: AEyebrowVariant;
  /** @deprecated Use `aHeader.text` instead. */
  headerText?: string;
  /** @deprecated Use `aHeader.size` instead. */
  headerSize?: AHeaderSize;
  /** @deprecated Use `aHeader.headerTag` instead. */
  headerTag?: AHeaderTag;
  /** @deprecated Use `aBody.bodyText` instead. */
  bodyText?: string;
  /** @deprecated Use `aBody.size` instead. */
  bodySize?: ABodySize;
  /** @deprecated Use `aBody.color` instead. */
  bodyColor?: ABodyColor;

  /**
   * Preferred nested props for the composed atoms.
   */
  aEyebrow?: Partial<Pick<AEyebrowProps, 'eyebrowText' | 'variant'>>;
  aHeader?: Partial<Pick<AHeaderProps, 'text' | 'size' | 'headerTag' | 'id'>>;
  aBody?: Partial<Pick<ABodyProps, 'bodyText' | 'size' | 'color' | 'className'>>;
}
